import React, { Fragment } from 'react'
import { Typography, SpacerHorizontal } from '@klarna/bubble-ui'
import { Node } from '../types'
import getValueFromNodes from '../utilities/getValueFromNode'
import PaymentInformationGenericLegal from './PaymentInformationGenericLegal/PaymentInformationGenericLegal'
import PaymentMethod from './PaymentMethod/PaymentMethod'
import styles from './PaymentInformationGeneric.css'
import PaymentStepsTimeline from '../components/PaymentStepsTimeline/PaymentStepsTimeline'
import config from '../config'
import RiskDisclaimer from '../components/RiskDisclaimer/RiskDeclaimer'

type PaymentInformationGenericProps = {
  nodes: Node[]
  theme: string
};

const PaymentInformationGeneric: React.FC<PaymentInformationGenericProps> = ({
  nodes,
  theme
}) => {
  const validPaymentMethods = config.paymentMethods.filter(pm => getValueFromNodes(nodes, `${pm.name}_HEADING`))
  const backgroundThemeKey = theme === 'dark' ? 'darkBackgroundTheme' : 'backgroundTheme'

  return (
    <Fragment>
      <style>{styles}</style>
      <Typography
        accessibilityPreset='heading 1'
        textToken="text-style/headings/titles/bold/tertiary"
        textAlignToken="text-alignment/start"
      >
        {getValueFromNodes(nodes, 'TITLE')}
      </Typography>
      <div className={`payment-methods grid-container grid-layout-${validPaymentMethods.length}`}>
        {
          validPaymentMethods.map((pm, index) => (
            <PaymentMethod
              heading={getValueFromNodes(nodes, `${pm.name}_HEADING`)}
              paragraph={getValueFromNodes(nodes, `${pm.name}_PARAGRAPH`)}
              index={index}
              frameBackground={config[backgroundThemeKey].frame_component}
              paymentMethodIllustration={pm.illustration}/>
          ))
        }
      </div>
      <SpacerHorizontal spaceToken='space.400' />
      <PaymentInformationGenericLegal nodes={nodes}></PaymentInformationGenericLegal>
      <SpacerHorizontal spaceToken='space.400' />
      <PaymentStepsTimeline
        nodes={nodes}
        frameBackground={config[backgroundThemeKey].frame_component}></PaymentStepsTimeline>
      <RiskDisclaimer
        frameBackground={config[backgroundThemeKey].frame_component}
        riskDesclaimerHeading={getValueFromNodes(nodes, 'FIXED_SUM_CREDIT_RISK_DISCLAIMER_HEADING') || ''}
        riskDisclaimerSubHeading={getValueFromNodes(nodes, 'FIXED_SUM_CREDIT_RISK_DISCLAIMER_SUBHEADING') || ''}
        riskDesclaimerSource={getValueFromNodes(nodes, 'FIXED_SUM_CREDIT_RISK_DISCLAIMER_SOURCE') || ''} />
      <SpacerHorizontal spaceToken="space.400" />
    </Fragment>
  )
}

export default PaymentInformationGeneric
